import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function PolicyModal({
  isOpen,
  onClose,
  title,
  content
}: PolicyModalProps) {
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-144">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50" data-id="element-145" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-146">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden" data-id="element-147">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-slate-100 bg-[#fef3e2]/30" data-id="element-148">
                <h2 className="text-2xl font-bold text-slate-900 font-serif" data-id="element-149">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 transition-colors" aria-label="Cerrar" data-id="element-150">
                  <X className="w-5 h-5 text-slate-600" data-id="element-151" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-152">
                <div className="prose prose-slate max-w-none" data-id="element-153">{content}</div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}